var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      



















































































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_mixins["summary-box"] = pug_interp = function(selectedCompany, save, disabled, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"summary-box isTransparent\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns\"\u003E";
if (selectedCompany) {
pug_html = pug_html + "\u003Cspan class=\"summary-box__title\"\u003E\u003Cstrong\u003EFirma:\u003C\u002Fstrong\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = ' '+ selectedCompany) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"hide-for-small-only\"\u003E&nbsp;\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns text-right pull-right\"\u003E";
block && block();
if (save) {
pug_html = pug_html + "\u003Cbutton" + (" class=\"button button-primary isOutline\""+pug.attr("ng-click", save, true, true)+pug.attr("ng-disabled", disabled, true, true)+pug.attr("data-cy", cyData, true, true)) + "\u003ESpeichern\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};



















pug_html = pug_html + "\u003Cdiv class=\"cockpit_steuerfrei-wrapper\"\u003E";
pug_mixins["summary-box"](
    '{{ SteuerfreiCtrl.customer.name }}', 
    'SteuerfreiCtrl.save()', 
    '!SteuerfreiCtrl.neo_project || SteuerfreiCtrl.modulesWorking || SteuerfreiCtrl.configuration.fixated',
    'vn.cockpit.neo.customerToolbar.buttonSaveSettings'
  );
pug_html = pug_html + "\u003Cdiv ng-if=\"SteuerfreiCtrl.neo_project\"\u003E";




















































































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_mixins["summary-box"] = pug_interp = function(selectedCompany, save, disabled, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"summary-box isTransparent\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns\"\u003E";
if (selectedCompany) {
pug_html = pug_html + "\u003Cspan class=\"summary-box__title\"\u003E\u003Cstrong\u003EFirma:\u003C\u002Fstrong\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = ' '+ selectedCompany) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"hide-for-small-only\"\u003E&nbsp;\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns text-right pull-right\"\u003E";
block && block();
if (save) {
pug_html = pug_html + "\u003Cbutton" + (" class=\"button button-primary isOutline\""+pug.attr("ng-click", save, true, true)+pug.attr("ng-disabled", disabled, true, true)+pug.attr("data-cy", cyData, true, true)) + "\u003ESpeichern\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};



















pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003ENeo-Projekt Einstellungen\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-4 columns\"\u003E\u003Clabel for=\"projectID\"\u003EProjektID\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-8 columns\"\u003E\u003Cinput id=\"projectID\" type=\"text\" ng-model=\"SteuerfreiCtrl.neo_project._id\" data-cy=\"vn.cockpit.neo.{{SteuerfreiCtrl.neo_project._id}}.inputProjectID\" readonly\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-4 columns\"\u003E\u003Clabel for=\"projectName\"\u003EProjektname\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-8 columns\"\u003E\u003Cinput id=\"projectName\" type=\"text\" ng-model=\"SteuerfreiCtrl.neo_project.name\" data-cy=\"vn.cockpit.neo.{{SteuerfreiCtrl.neo_project._id}}.inputProjectName\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-4 columns\"\u003E\u003Clabel for=\"zielvorgabe\"\u003EZielvorgabe:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-4 columns\"\u003E\u003Cselect id=\"zielvorgabe\" ng-model=\"SteuerfreiCtrl.neo_project.project.zielausgleich.mode\" ng-change=\"SteuerfreiCtrl.neo_project.project.zielausgleich.value = 0\" ng-options=\"option.value as option.name for option in SteuerfreiCtrl.EinsparungsModellConstants\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-3 medium-offset-1 columns\" ng-if=\"(SteuerfreiCtrl.neo_project.project.zielausgleich.mode == &quot;AN&quot;) || (SteuerfreiCtrl.neo_project.project.zielausgleich.mode == &quot;AG&quot;)\"\u003E\u003Cinput type=\"text\" ng-model=\"SteuerfreiCtrl.neo_project.project.zielausgleich.value\" vn-currency\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-3 medium-offset-1 columns\" ng-if=\"SteuerfreiCtrl.neo_project.project.zielausgleich.mode == &quot;AN_RELATIVE&quot;\"\u003E\u003Cinput type=\"text\" ng-model=\"SteuerfreiCtrl.neo_project.project.zielausgleich.value\" vn-percent\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-4 columns\"\u003E\u003Clabel for=\"alv_ktg\"\u003EALV\u002FKTG Ausgleich\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-8 columns\"\u003E\u003Cdiv class=\"medium-6 columns\"\u003E\u003Cselect id=\"alv_ktg\" ng-model=\"SteuerfreiCtrl.neo_project.project.metadata.behandlung_alvktg\" ng-options=\"option.value as option.name for option in SteuerfreiCtrl.ALVktgConstants\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-4 columns\"\u003E\u003Clabel for=\"supply_compensation\"\u003EVersorgungsausgleich\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-4 columns\"\u003E\u003Cselect id=\"supply_compensation\" ng-model=\"SteuerfreiCtrl.neo_project.project.insurances.va.typ\" ng-options=\"option.value as option.name for option in SteuerfreiCtrl.VATypeConstants\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-3 medium-offset-1 columns\"\u003E\u003Cinput type=\"text\" ng-model=\"SteuerfreiCtrl.neo_project.project.insurances.va.pension_interest\" vn-percent\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchProjectDefault\"\u003E\u003Cspan class=\"component-name\"\u003EDefault\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchProjectDefault","data-cy": "vn.cockpit.neo.{{SteuerfreiCtrl.neo_project._id}}.checkDefault","key": "SteuerfreiCtrl.neo_project.default_project","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchProjectApproved\"\u003E\u003Cspan class=\"component-name\"\u003EProjekt Freigegeben\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchProjectApproved","data-cy": "vn.cockpit.neo.{{SteuerfreiCtrl.neo_project._id}}.checkApproved","key": "SteuerfreiCtrl.neo_project.project.project_approved","labelHtmlClass": "switchbox-float-label","readonly": "!SteuerfreiCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchversorgungsausgleichAGfinanziert\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003EVersorgungsausgleich AG finanziert (Erforderlich bei \"Rentenabsicherung Freiwillig\")\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchversorgungsausgleichAGfinanziert","key": "SteuerfreiCtrl.neo_project.project.versorgungsausgleichAGfinanziert","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchPauschVereinfacht\"\u003E\u003Cspan class=\"component-name\"\u003EPauschalsteuer vereinfacht abgerechnet\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchPauschVereinfacht","key": "SteuerfreiCtrl.neo_project.project.pauschVereinfacht","labelHtmlClass": "switchbox-float-label","readonly": "!SteuerfreiCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchPauschZuEntgeltverzicht\"\u003E\u003Cspan class=\"component-name\"\u003EPauschalsteuer im Entgeltverzicht\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchPauschZuEntgeltverzicht","key": "SteuerfreiCtrl.neo_project.project.pauschZuEntgeltverzicht","labelHtmlClass": "switchbox-float-label","readonly": "!SteuerfreiCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchCompensationRente\"\u003E\u003Cspan class=\"component-name\"\u003ERentenabsicherung Freiwillig\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchCompensationRente","key": "SteuerfreiCtrl.neo_project.project.compensationRente","labelHtmlClass": "switchbox-float-label","readonly": "!SteuerfreiCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchCompensationALV\"\u003E\u003Cspan class=\"component-name\"\u003EALV\u002FKTG Ausgleich durch Arbeitgeber\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchCompensationALV","key": "SteuerfreiCtrl.neo_project.project.compensationALV","labelHtmlClass": "switchbox-float-label","readonly": "!SteuerfreiCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cp\u003EDie Neo-Projekt-Einstellungen gelten nur für Arbeitnehmer, die nach Festlegen der Einstellungen angelegt werden.\nFür bereits angelegte Arbeitnehmer können diese individuell im Profirechner angepasst werden.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EAbeitgeber-Code\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"columns small-3\"\u003E\u003Clabel class=\"control-label\" for=\"customer-code\"\u003EAktueller Code\u003C\u002Flabel\u003E\u003Cinput class=\"form-control\" id=\"customer-code\" disabled ng-model=\"SteuerfreiCtrl.custCode\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8\"\u003E\u003Cbr\u003E\u003Cdiv class=\"reg-btn-container\"\u003E\u003Cbutton class=\"button-primary\" ng-if=\"SteuerfreiCtrl.custCode == &quot;Noch keiner vorhanden&quot;\" ng-click=\"SteuerfreiCtrl.createCode()\"\u003ECode erstellen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button-primary\" ng-if=\"SteuerfreiCtrl.iAmSpecialAdvisor\" ng-click=\"SteuerfreiCtrl.createNewCode()\"\u003ENeuen Code erstellen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button-primary\" ng-if=\"SteuerfreiCtrl.hasAccessForLinkOrQr()\" ng-click=\"SteuerfreiCtrl.openModalWithRegCode()\"\u003ERegistrierungslink\u003C\u002Fbutton\u003E\u003Cbutton class=\"button-primary qr-code\" ng-if=\"SteuerfreiCtrl.hasAccessForLinkOrQr()\" ng-click=\"SteuerfreiCtrl.openQRCode()\"\u003EQR-Code\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EBAV Zuschuss\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"columns small-3\"\u003E\u003Clabel class=\"control-label\" for=\"bav-zuschuss\"\u003E% Zuschuss\u003C\u002Flabel\u003E\u003Cinput class=\"form-control\" id=\"bav-zuschuss\" type=\"number\" min=\"0\" max=\"100\" ng-model=\"SteuerfreiCtrl.neo_project.project.insurances.bav.value\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8\"\u003E\u003Cdiv class=\"checkbox schema-form-checkbox\"\u003E\u003Cinput type=\"checkbox\" ng-disabled=\"!SteuerfreiCtrl.iAmSpecialAdvisor\" ng-model=\"SteuerfreiCtrl.neo_project.project.insurances.bav.noValidateMin\" id=\"bav-comp-validate\"\u003E\u003Clabel for=\"bav-comp-validate\"\u003E\u003Cspan\u003EZuschuss wird zwar berechnet, kann aber auch manuell unterschritten werden\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EInfomodus und Selfservice\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cp\u003ESchaltet die Ergebnisansicht für Arbeitnehmer ab und ersetzt den\nCheckout durch Kontaktangebot zum Berater.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"key": "SteuerfreiCtrl.neo_project.infomode","title": "Nur Informationsansicht aus\u002Fan","labelHtmlClass": "switchbox-float-label","readonly": "!SteuerfreiCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-show=\"!SteuerfreiCtrl.neo_project.infomode\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Chr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-show=\"!SteuerfreiCtrl.neo_project.infomode\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cp\u003EErlaubt den vollen Selfservice aber ersetzt den Checkout durch\nKontaktangebot zum Berater.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-show=\"!SteuerfreiCtrl.neo_project.infomode\"\u003E\u003Cdiv class=\"columns\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"key": "SteuerfreiCtrl.neo_project.noSelfCheckout","title": "Selfservice Checkout durch Beraterkontakt ersetzen","labelHtmlClass": "switchbox-float-label","readonly": "!SteuerfreiCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cdiv ng-if=\"!SteuerfreiCtrl.iAmSpecialAdvisor\"\u003E\u003Ch3\u003E\u003Csmall\u003EZum ändern dieser Eigenschaften wenden Sie sich bitte an die Verwaltung.\u003C\u002Fsmall\u003E\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EBausteine aktivieren\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 small-6 columns\"\u003EModul\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003EProfirechner\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003ESelf Service\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 small-6 columns\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E\u003Ca ng-click=\"SteuerfreiCtrl.reverseSelection()\"\u003EAuswahl umkehren\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E\u003Ca ng-click=\"SteuerfreiCtrl.reverseSelection(true)\"\u003EWie Profirechner\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"component in SteuerfreiCtrl.availableComponents | orderBy\" ng-class=\"{ isSelected: SteuerfreiCtrl.neo_project.neo_components[component].enabled }\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-6 columns component-col\"\u003E\u003Clabel for=\"switchbox{{ component }}\" tabindex=\"1\"\u003E\u003Ch5\u003E\u003Ci class=\"font-icon icon-{{ component | bausteinIcon }}\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"component-name\"\u003E\u003Cspan class=\"show-for-medium-up\"\u003E&nbsp;\u003C\u002Fspan\u003E{{ component | bausteinTitle }}\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003C\u002Flabel\u003E\u003Ca ng-show=\"SteuerfreiCtrl.neo_project.neo_components[component].enabled &amp;&amp; component !== &quot;car_leasing&quot;\" ng-click=\"SteuerfreiCtrl.openDialog(component)\"\u003Ebearbeiten\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchbox{{ component }}","key": "SteuerfreiCtrl.neo_project.neo_components[component].enabled"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchbox-{{ component }}","key": "SteuerfreiCtrl.neo_project.neo_components[component].selfservice"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-show=\"SteuerfreiCtrl.neo_project.neo_components[component].enabled\"\u003E\u003Cdiv class=\"xsmall-12 small-9 columns text-right\"\u003E\u003Cspan ng-if=\"SteuerfreiCtrl.neo_project.neo_components[component].pst\"\u003Ep.ST: {{ SteuerfreiCtrl.neo_project.neo_components[component].pst }};" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan ng-if=\"SteuerfreiCtrl.neo_project.neo_components[component].value\"\u003EWert: {{ SteuerfreiCtrl.neo_project.neo_components[component].value | currency }};" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan ng-if=\"SteuerfreiCtrl.neo_project.neo_components[component].anzahl_gutscheine\"\u003EGutscheine: {{ SteuerfreiCtrl.neo_project.neo_components[component].anzahl_gutscheine }};" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan ng-if=\"SteuerfreiCtrl.neo_project.neo_components[component].anzahl_km\"\u003E{{ SteuerfreiCtrl.neo_project.neo_components[component].anzahl_km }}km;" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan ng-if=\"SteuerfreiCtrl.neo_project.neo_components[component].anzahl_tage\"\u003E{{ SteuerfreiCtrl.neo_project.neo_components[component].anzahl_tage }} Tage;" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan ng-if=\"SteuerfreiCtrl.neo_project.neo_components[component].anzahl_std_abwesend\"\u003E{{ SteuerfreiCtrl.neo_project.neo_components[component].anzahl_std_abwesend }} h;" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan ng-if=\"SteuerfreiCtrl.neo_project.neo_components[component].cent_pro_km\"\u003E{{ SteuerfreiCtrl.neo_project.neo_components[component].cent_pro_km | currency }}\u002Fkm;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"SteuerfreiCtrl.iAmSpecialAdvisor\" ng-class=\"{ isSelected: SteuerfreiCtrl.neo_project.neo_components.besonderer_anlass.enabled }\"\u003E\u003Chr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 small-6 columns component-col\"\u003E\u003Clabel for=\"switchboxbesonderer_anlass\" tabindex=\"1\"\u003E\u003Ch5\u003E\u003Ci class=\"font-icon icon-{{ &quot;besonderer_anlass&quot; | bausteinIcon }}\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"component-name\"\u003E&nbsp; {{ \"besonderer_anlass\" | bausteinTitle }}\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchboxbesonderer_anlass","key": "SteuerfreiCtrl.neo_project.neo_components.besonderer_anlass.enabled"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EMitarbeiter zuweisen\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"SteuerfreiCtrl.saveParticipants()\" ng-disabled=\"SteuerfreiCtrl.working\"\u003EZuweisung speichern\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 small-9 columns\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E\u003Ca ng-click=\"SteuerfreiCtrl.reverseParticipantSelection()\"\u003EAuswahl umkehren\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"participant in SteuerfreiCtrl.employees | orderBy:&quot;name&quot;\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchbox{{ participant.id }}\" tabindex=\"1\"\u003E\u003Ch5\u003E\u003Cspan class=\"component-name\"\u003E\u003Cspan class=\"show-for-medium-up\"\u003E&nbsp;\u003C\u002Fspan\u003E{{ participant.name }}, {{ participant.vorname }} ({{ participant.id }})\u003C\u002Fspan\u003E\u003C\u002Fh5\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchbox{{ participant.id }}","key": "SteuerfreiCtrl.neoProjectParticipants[participant.id]"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"!SteuerfreiCtrl.neo_project\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003ENeo-Projekt auswählen\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cp\u003EBitte wählen Sie ein Neo-Projekt zum Bearbeiten.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cdiv ng-repeat=\"project in SteuerfreiCtrl.neoProjectList\"\u003E\u003Ca ui-sref=\"inApp.cockpit.steuerfrei({customerId:SteuerfreiCtrl.customerId, neoProjectId:project._id})\" data-cy=\"vn.cockpit.neo.neoProjects.linkNeoProject-{{project._id}}\"\u003E{{ project.name }}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cp ng-if=\"!SteuerfreiCtrl.neoProjectList\"\u003EEs sind noch keine Projekte für diesen AG vorhanden.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"spacer margin-top\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"SteuerfreiCtrl.newNeoProject()\" ng-disabled=\"SteuerfreiCtrl.configuration.fixated\" data-cy=\"vn.cockpit.neo.neoProjects.buttonNewProject\"\u003ENeues Neo Projekt\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;